import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ADMIN_ROUTES } from '../pages/admin/routing/admin.routes';
import { consentGuard } from '../pages/consent/consent-guard';
import { consultationResolver } from '../pages/consultation/routing/consultation-resolver';
import { newConsultationGuard } from '../pages/consultation/routing/new-consultation.guard';
import { ROUTE_PATHS } from './routes.pojo';

export const routes: Routes = [
  {
    path: ROUTE_PATHS._,
    canActivate: [MsalGuard],
    children: [
      {
        path: ROUTE_PATHS._,
        loadComponent: () => import('../pages/home/home').then((c) => c.Home),
      },
      {
        path: ROUTE_PATHS.consultation,
        canActivate: [consentGuard, newConsultationGuard],
        loadComponent: () =>
          import('../pages/consultation/consultation/consultation').then(
            (c) => c.Consultation,
          ),
      },
      {
        path: `${ROUTE_PATHS.consultation}/${ROUTE_PATHS.consultation_guid}`,
        canActivate: [consentGuard],
        loadComponent: () =>
          import('../pages/consultation/consultation/consultation').then(
            (c) => c.Consultation,
          ),
        resolve: { consultation: consultationResolver },
      },
      ...ADMIN_ROUTES,
    ],
  },
  {
    path: '**',
    redirectTo: ROUTE_PATHS._,
  },
];
